"use strict";

import Vue from "vue";
import axios from "axios";
import store from "../store";
import { authService } from "@/services";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.VUE_APP_API_URL
};

const _axios = axios.create(config);

let isRefreshing = false;
let subscribers = [];

_axios.interceptors.request.use(
  function(config) {
    const accessToken = store.getters["auth/getAccessToken"];

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    const {
      config,
      response: { status }
    } = error;

    const originalRequest = config;

    if (
      status === 401 &&
      !isRefreshRoute(config.url) &&
      !isAuthRoute(config.url)
    ) {
      if (!isRefreshing) {
        isRefreshing = true;
        const currentRefreshToken = store.getters["auth/getRefreshToken"];

        authService
          .refresh(currentRefreshToken)
          .then(response => {
            isRefreshing = false;

            const newAccessToken = response.data.access;
            const newRefreshToken = response.data.refresh;

            store.dispatch("auth/setTokens", {
              access: newAccessToken,
              refresh: newRefreshToken
            });

            onRefreshed(newAccessToken);
            subscribers = [];
          })
          .catch(() => {
            store.dispatch("auth/logout");
          });
      }

      return new Promise(resolve => {
        subscribeTokenRefresh(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          resolve(axios(originalRequest));
        });
      });
    }

    // Do something with response error
    return Promise.reject(error);
  }
);

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRefreshed(token) {
  subscribers.map(cb => cb(token));
}

function isRefreshRoute(url) {
  url = url.split("/");
  return url[url.length - 1] === "refresh";
}

function isAuthRoute(url) {
  url = url.split("/");
  return url[url.length - 1] === "jwt_token";
}

// eslint-disable-next-line no-unused-vars
Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
